import React, { useState } from 'react';
import { Button } from '../components/Button';
import { Header } from '../components/Header';
import { apiClient } from '../api/client';
import { useAppStore } from '../store/useAppStore';
import './RequestPasswordResetScreen.css';

export const RequestPasswordResetScreen: React.FC = () => {
  const { setCurrentPage } = useAppStore();
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    
    // Валидация email
    if (!email) {
      setError('Введите email');
      return;
    }
    
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setError('Введите корректный email');
      return;
    }

    try {
      setIsProcessing(true);
      
      await apiClient.requestPasswordReset(email.toLowerCase().trim());
      
      setSuccess(true);
      console.log('✅ Password reset email sent');
    } catch (error: any) {
      console.error('Password reset request error:', error);
      setError(error.message || 'Ошибка отправки запроса');
    } finally {
      setIsProcessing(false);
    }
  };


  if (success) {
    return (
      <div className="password-reset-screen">
        <div className="password-reset-container">
          <div className="success-message">
            <div className="success-icon">
              <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="30" cy="30" r="30" fill="url(#paint0_linear_success)" />
                <path d="M20 30L27 37L42 22" stroke="white" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/>
                <defs>
                  <linearGradient id="paint0_linear_success" x1="0" y1="0" x2="60" y2="60" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#34C759" />
                    <stop offset="1" stopColor="#30D158" />
                  </linearGradient>
                </defs>
              </svg>
            </div>
            
            <h2 className="success-title">Письмо отправлено!</h2>
            
            <p className="success-text">
              Мы отправили инструкции по восстановлению пароля на адрес <strong>{email}</strong>
            </p>
            
            <p className="success-hint">
              Проверьте почту (включая папку "Спам") и перейдите по ссылке в письме.
            </p>

            <div className="success-actions">
              <Button
                variant="primary"
                onClick={() => setCurrentPage('home')}
                style={{ width: '100%', padding: '14px' }}
              >
                На главную
              </Button>
              
              <button
                className="link-button"
                onClick={() => {
                  setSuccess(false);
                  setEmail('');
                  setRecaptchaToken(null);
                }}
              >
                Отправить письмо еще раз
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="password-reset-screen">
      <div className="password-reset-container">
        <Header title="Восстановление пароля" onBack={() => setCurrentPage('home')} />

        <div className="password-reset-header">
          <div className="reset-icon">
            <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="24" cy="24" r="24" fill="url(#paint0_linear_reset)" opacity="0.1" />
              <path d="M16 20C16 15.5817 19.5817 12 24 12C28.4183 12 32 15.5817 32 20V22H34V20C34 14.4772 29.5228 10 24 10C18.4772 10 14 14.4772 14 20V22H16V20Z" fill="url(#paint0_linear_reset)"/>
              <rect x="18" y="22" width="12" height="14" rx="2" fill="url(#paint0_linear_reset)"/>
              <circle cx="24" cy="29" r="2" fill="white"/>
              <defs>
                <linearGradient id="paint0_linear_reset" x1="16" y1="10" x2="32" y2="36" gradientUnits="userSpaceOnUse">
                  <stop stopColor="#667eea" />
                  <stop offset="1" stopColor="#764ba2" />
                </linearGradient>
              </defs>
            </svg>
          </div>
          <h1 className="reset-title">Восстановление пароля</h1>
          <p className="reset-subtitle">
            Введите email, указанный при регистрации, и мы отправим вам ссылку для восстановления пароля
          </p>
        </div>

        <form onSubmit={handleSubmit} className="password-reset-form">
          <div className="form-group">
            <label htmlFor="email" className="form-label">
              Email
            </label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="email@example.com"
              className="form-input"
              disabled={isProcessing}
              autoComplete="email"
              autoFocus
            />
          </div>

          {error && (
            <div className="error-message">
              {error}
            </div>
          )}

          <Button
            type="submit"
            variant="primary"
            disabled={isProcessing || !email}
            style={{ width: '100%', padding: '14px' }}
          >
            {isProcessing ? 'Отправка...' : 'Отправить ссылку'}
          </Button>
        </form>

        <div className="password-reset-footer">
          <p className="footer-text">
            Вспомнили пароль?{' '}
            <button 
              className="footer-link"
              onClick={() => setCurrentPage('home')}
            >
              Войти
            </button>
          </p>
        </div>
      </div>
    </div>
  );
};

